export const fromRefiner_SearchPlaceholder = "hWHcxd";
export const fromRefiner_RemovePerson = "feL3Xc";
export const fromRefiner_ClearSearch = "$AIoWc";
export const fromRefiner_Suggestions = "nTZ$g";
export const fromRefiner_Loading = "opD5od";
export const fromRefiner_NoSuggestions = "STPGKe";
export const fromRefiner_SelectedPerson = "GEX_6d";
export const fromRefiner_SelectedCount = "odyJY";
export default {fromRefiner_SearchPlaceholder,fromRefiner_RemovePerson,fromRefiner_ClearSearch,fromRefiner_Suggestions,fromRefiner_Loading,fromRefiner_NoSuggestions,fromRefiner_SelectedPerson,fromRefiner_SelectedCount};